import { APIInstance } from "./api.config";

const { api } = new APIInstance({ path: "/v2/users/" });
const { api: newApi } = new APIInstance({ path: "/v1/users/" });

export const UserService = {
  resetPassword: ({ id, password }) => {
    return api.put(`${id}/reset-password`, { password });
  },

  resetUserPassword: ({ id, password }) => {
    return api.put(`${id}/reset-user-password`, { password });
  },

  getUsers: (filters) => {
    let url = "";
    // Add query parameters if they exist
    const queryParams = [];
    if (filters.page) queryParams.push(`page=${filters.page}`);
    if (filters.limit) queryParams.push(`limit=${filters.limit}`);
    if (filters.type) queryParams.push(`type=${filters.type}`);
    if (filters.searchText) queryParams.push(`name=${filters.searchText}`);
    if (filters.companyId) queryParams.push(`companyId=${filters.companyId}`);
    if (filters.ids?.length) queryParams.push(`ids=${filters.ids.join(",")}`);

    if (queryParams.length > 0) {
      url += `?${queryParams.join("&")}`;
    }

    return newApi.get(url);
  },

  getUserById: (id) => {
    return newApi.get(`${id}`);
  },
};
